import { Badge } from "reactstrap";
import {
  FaCheckCircle,
  FaUsers,
  FaUniversity,
  FaPercent,
} from "react-icons/fa";
import { GroupDto } from "../../types/Group";

interface Props {
  group: GroupDto;
}

const ProductHeroSection = ({ group }: Props) => {
  return (
    <div className="py-lg-12 py-4">
      <Badge
        color="light"
        pill
        className="px-3 text-muted py-2 mb-3"
      >
        Featured Product
      </Badge>

      <h1
        className="fw-bold mb-3"
        style={{
          fontSize: "clamp(2rem,5vw,3.2rem)",
          lineHeight: 1.2,
        }}
      >
        {group.groupName}
      </h1>

      <h3
        className="fw-semibold text-primary mb-4"
        style={{
          fontSize: "clamp(1.1rem,2vw,1.5rem)",
        }}
      >
        <strong>Join Together. Negotiate Together. Save More.</strong>
      </h3>

      <p
        className="text-muted"
        style={{
          maxWidth: "1050px",
          fontSize: "1.08rem",
          lineHeight: "1.8",
        }}
      >
        <strong>Planning to buy {group.groupName}</strong>
        <br />
        Don't buy alone.
        <br />
       Join a buying group of 10 to 100+ people who are also planning to {group.groupName}. By negotiating together, the group can 
         better prices, exclusive discounts, additional benefits, and special offers from sellers or service providers.
        <br />
        <strong>The bigger the group, the better the deal.</strong>
      </p>

      <div className="row mt-4 gy-3">
        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaPercent
              className="text-success mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Best Price
              </h6>

              <small className="text-muted">
                Enjoy competitive pricing and exclusive offers.
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaUniversity
              className="text-primary mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Premium Quality
              </h6>

              <small className="text-muted">
                Crafted with high-quality materials for lasting performance.
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaUsers
              className="text-warning mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Trusted by Customers
              </h6>

              <small className="text-muted">
                Highly rated by customers for quality and reliability.
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaCheckCircle
              className="text-success mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Satisfaction Guaranteed
              </h6>

              <small className="text-muted">
                Buy with confidence backed by quality assurance and support.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductHeroSection;